import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_CATEGORIZED_WORDS, GET_VOCABULARY_LIST } from '@/graphql/Mystage/vocabulary';
import { bizmatesApi } from '@/utils/bizmatesApi';
import logger from '@/modules/Logger';

/**
 * Class handler for the API endpoint, whether to use the old/legacy endpoint or the new ones
 */
export const CategorizedWordService = {
  msb: async (params, callback) => {
    logger.debug(`[GetVocabularyList] Fetching vocabulary list from MSB GraphQL endpoint`, {
      operation: 'vocabulary:get-vocabulary-list'
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.query({
      fetchPolicy: 'no-cache',
      query: GET_VOCABULARY_LIST,
      variables: {
        lesson_id: parseInt(params.lesson_id)
      }
    });

    if (data?.getVocabularyList && data.getVocabularyList?.hits) {
      callback(data.getVocabularyList);
    } else {
      logger.error(
        `[GetVocabularyList][Lesson No ${params.lesson_id}] Empty result from materials api`,
        { operation: 'vocabulary:get-vocabulary-list', event_type: 4, lesson_id: params.lesson_id }
      );
    }
  },

  // Method to fetch categorized words from MBTI backend
  mbti: async (params, callback) => {
    logger.debug(`[CategorizedWord] Fetching categorized words from MBTI GraphQL endpoint`, {
      operation: 'vocabulary:categorized_words'
    });

    const client = apolloProvider.defaultClient;
    const { data } = await client.query({
      fetchPolicy: 'no-cache',
      query: GET_CATEGORIZED_WORDS,
      variables: {
        lesson_id: parseInt(params.lesson_id)
      }
    });

    if (data?.categorized_words && data.categorized_words?.hits) {
      callback(data.categorized_words);
    } else {
      logger.error(
        `[CategorizedWord][Lesson No ${params.lesson_id}] Empty result from materials api`,
        { operation: 'vocabulary:categorized_words', event_type: 4, lesson_id: params.lesson_id }
      );
    }
  },

  // Method to fetch categorized words from legacy REST API endpoint
  legacy: async (params, callback) => {
    logger.debug(`[CategorizedWord] Fetching categorized words from legacy endpoint`, {
      operation: 'vocabulary:categorized_words'
    });

    await bizmatesApi.get('vocabulary/categorized_words', { params }, (response) => {
      if (response.data !== undefined && Object.keys(response.data).length > 0) {
        callback(response.data.result);
      } else {
        logger.error(
          `[CategorizedWord][Lesson No ${params.lesson_id}] Empty result from materials api`,
          { operation: 'vocabulary:categorized_words', event_type: 4, lesson_id: params.lesson_id }
        );
      }
    });
  }
};
